export default __webpack_public_path__ + "static/media/ServicesMain1.1199a795.svg";